// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { showSnackBar } from "../../snackbar/actions"
import { timesheetFieldClient } from "../../../app/rpc/client"
import {
  ListFavouriteTimesheetFieldOptionsRequest,
  ListFavouriteTimesheetFieldOptionsResponse,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type ListFavouriteTimesheetFieldOptionsRpc = (request: ListFavouriteTimesheetFieldOptionsRequest) => Observable<ListFavouriteTimesheetFieldOptionsResponse>

export const listFavouriteTimesheetFieldOptions = (listFavouriteTimesheetFieldOptionsRpc: ListFavouriteTimesheetFieldOptionsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.listFavouriteTimesheetFieldOptions.match),
      mergeMap((action) => of(action.payload)
        .pipe(
          mergeMap(listFavouriteTimesheetFieldOptionsRpc),
          map(response => ({ siteId: action.payload.getSiteId(), options: response.toObject().timesheetFieldOptionsList })),
          map(Slice.setFavouriteTimesheetFieldOptions),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_list_favourite_timesheet_field_options_failed",
              message: "Failed to load favourite timesheet field options. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )),
    )

const listFavouriteTimesheetFieldOptionsRpc = (request: ListFavouriteTimesheetFieldOptionsRequest): Observable<ListFavouriteTimesheetFieldOptionsResponse> =>
  grpc(() => timesheetFieldClient.listFavouriteTimesheetFieldOptions(request, null))

export default listFavouriteTimesheetFieldOptions(listFavouriteTimesheetFieldOptionsRpc)
